export default __webpack_public_path__ + "static/blootropic-logo-colored-seo-fb3f3f080dca2491a7d34e0f1a5c6a22.png";